import { APP_NAME, APP_NAME_ML, APP_TAGLINE } from "@/lib/api";

export const Brand = ({ size = "md", tagline = true, dark = false, compact = false, ml = false }) => {
  const img = size === "lg" ? "w-12 h-12" : size === "sm" ? "w-7 h-7" : "w-9 h-9";
  return (
    <span className="inline-flex items-center gap-2.5 shrink-0">
      <img data-testid="brand-logo" src="/icons/eraathri-logo.png" alt={ml ? APP_NAME_ML : APP_NAME} className={`${img} rounded-full object-cover border border-fuchsia-100 shadow-sm`} draggable={false} />
      <span className={`flex flex-col leading-none ${compact ? "hidden sm:flex" : ""}`}>
        <span className={`font-display font-extrabold tracking-wide ${dark ? "text-white" : "text-[#7b2d8b]"} ${size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl"}`}>{ml ? APP_NAME_ML : APP_NAME}</span>
        {tagline && <span className={`text-[9px] font-semibold mt-1 ${tagline === "sm" ? "hidden sm:inline" : ""} ${dark ? "text-sky-100/80" : "text-[var(--muted-text)]"}`}>{APP_TAGLINE}</span>}
      </span>
    </span>
  );
};
